export default "images/stanley2.jpg";